<template>
  <RrForm class="ren-page-inspector" layout="vertical" size="small">
    <RrFormItem>
      <template #label>
        页面标题
        <TemplateLockMark :locked="isLocked('title')" />
      </template>
      <RrInput
        :disabled="isDisabled('title')"
        :title="fieldTitle('title')"
        :value="page.title"
        placeholder="请输入页面标题"
        @update:value="(val) => emit('update:page', 'title', String(val))"
      />
    </RrFormItem>
    <RrFormItem>
      <template #label>
        页面模式
        <TemplateLockMark :locked="isLocked('layoutMode')" />
      </template>
      <RrSelect
        :disabled="isDisabled('layoutMode')"
        :title="fieldTitle('layoutMode')"
        :value="layoutMode"
        :options="layoutModeOptions"
        @update:value="(val) => emit('update:page', 'layoutMode', String(val))"
      />
    </RrFormItem>
    <RrFormItem>
      <template #label>
        页面头部
        <TemplateLockMark :locked="isLocked('headerMode')" />
      </template>
      <RrSelect
        :disabled="isDisabled('headerMode')"
        :title="fieldTitle('headerMode')"
        :value="headerMode"
        :options="headerModeOptions"
        @update:value="(val) => emit('update:page', 'headerMode', String(val))"
      />
    </RrFormItem>

    <RrFormItem label="发布平台">
      <RrSelect
        :disabled="isDisabled('platforms')"
        :value="Array.isArray(page.platforms) && page.platforms.length === 1 && page.platforms[0] === 'APP' ? 'APP' : 'DEFAULT'"
        :options="[{ label: '默认客户端平台', value: 'DEFAULT' }, { label: 'APP', value: 'APP' }]"
        @update:value="(val) => emit('update:page', 'platforms', val === 'APP' ? ['APP'] : [])"
      />
    </RrFormItem>
    <section v-if="tabbarShellPage" class="ren-page-inspector__tabbar">
      <header>
        <div>
          <strong>底部 TabBar <TemplateLockMark :locked="isLocked('tabbar')" /></strong>
          <span>App 壳统一管理导航，业务页面只引用这一份配置。</span>
        </div>
        <RrButton
          type="primary"
          size="small"
          :disabled="isDisabled('tabbar') || tabbar.items.length >= 5"
          :title="fieldTitle('tabbar')"
          @click="emit('tabbar-add')">
          添加导航
        </RrButton>
      </header>
      <div class="ren-page-inspector__color-grid">
        <RrFormItem v-for="field in tabbarColorFields" :key="field.code">
          <template #label>{{ field.label }}</template>
          <RrColorPicker
            :disabled="isDisabled('tabbar')"
            :title="fieldTitle('tabbar')"
            :model-value="tabbarColor(field.code)"
            @update:model-value="(val) => emit('tabbar-change', field.code, String(val))"
          />
        </RrFormItem>
      </div>
      <RrFormItem>
        <template #label>导航高度</template>
        <RrInputNumber
          :disabled="isDisabled('tabbar')"
          :title="fieldTitle('tabbar')"
          :value="tabbar.height"
          :min="52"
          :max="88"
          @update:value="(val) => emit('tabbar-change', 'height', Number(val || 58))"
        />
      </RrFormItem>
      <article v-for="(item, index) in tabbar.items" :key="item.code" class="ren-page-inspector__tab">
        <header>
          <div>
            <strong>{{ index + 1 }}. {{ item.text || '未命名导航' }}</strong>
            <span>{{ item.routePath || '尚未选择业务页' }}</span>
          </div>
          <div class="ren-page-inspector__tab-actions">
            <RrButton
              size="small"
              type="default"
              :disabled="isDisabled('tabbar') || index === 0"
              aria-label="上移"
              @click="emit('tabbar-move', index, -1)">
              <ArrowUp :size="13" />
            </RrButton>
            <RrButton
              size="small"
              type="default"
              :disabled="isDisabled('tabbar') || index === tabbar.items.length - 1"
              aria-label="下移"
              @click="emit('tabbar-move', index, 1)">
              <ArrowDown :size="13" />
            </RrButton>
            <RrButton
              size="small"
              type="primary" danger
              :disabled="isDisabled('tabbar') || tabbar.items.length <= 2"
              aria-label="删除"
              @click="emit('tabbar-remove', index)">
              <Trash2 :size="13" />
            </RrButton>
          </div>
        </header>
        <div class="ren-page-inspector__tab-fields">
          <RrFormItem label="显示名称">
            <RrInput
              :disabled="isDisabled('tabbar')"
              maxlength="6"
              :value="item.text"
              placeholder="如 首页"
              @update:value="(val) => emit('tabbar-item-change', index, 'text', String(val))"
            />
          </RrFormItem>
          <RrFormItem label="导航编码">
            <RrInput
              :disabled="isDisabled('tabbar')"
              maxlength="32"
              :value="item.code"
              placeholder="如 home"
              @update:value="(val) => emit('tabbar-item-code', index, String(val))"
            />
          </RrFormItem>
          <RrFormItem label="默认图标">
            <RrInput
              :disabled="isDisabled('tabbar')"
              :value="item.icon || ''"
              placeholder="图标名称"
              @update:value="(val) => emit('tabbar-item-change', index, 'icon', String(val))"
            />
          </RrFormItem>
          <RrFormItem label="选中图标">
            <RrInput
              :disabled="isDisabled('tabbar')"
              :value="item.activeIcon || ''"
              placeholder="高亮图标名称"
              @update:value="(val) => emit('tabbar-item-change', index, 'activeIcon', String(val))"
            />
          </RrFormItem>
        </div>
        <div class="ren-page-inspector__tab-target">
          <div>
            <strong>{{ item.action ? '动作入口' : '独立装修页' }}</strong>
            <span>{{ item.pageCode || '不加载装修页，直接按地址跳转' }}</span>
          </div>
          <div class="ren-page-inspector__tab-actions">
            <RrButton
              v-if="!item.action && item.pageCode"
              type="primary"
              size="small"
              @click="emit('tabbar-open-page', item)">
              装修页面
            </RrButton>
            <RrButton
              size="small"
              :disabled="isDisabled('tabbar') || linkTargetCount === 0"
              @click="emit('tabbar-open-nav', index)">
              更换绑定
            </RrButton>
          </div>
        </div>
        <div class="ren-page-inspector__switches">
          <div class="ren-page-inspector__switch">
            <span>需要登录</span>
            <RrSwitch
              :checked="Boolean(item.loginRequired)"
              :disabled="isDisabled('tabbar')"
              @update:checked="(val) => emit('tabbar-item-change', index, 'loginRequired', Boolean(val))"
            />
          </div>
          <div class="ren-page-inspector__switch">
            <span>动作按钮</span>
            <RrSwitch
              :checked="Boolean(item.action)"
              :disabled="isDisabled('tabbar')"
              @update:checked="(val) => emit('tabbar-action', index, Boolean(val))"
            />
          </div>
          <div class="ren-page-inspector__switch">
            <span>突出显示</span>
            <RrSwitch
              :checked="Boolean(item.prominent || tabbar.prominentCode === item.code)"
              :disabled="isDisabled('tabbar')"
              @update:checked="(val) => emit('tabbar-prominent', index, Boolean(val))"
            />
          </div>
        </div>
      </article>
      <p class="ren-page-inspector__hint">支持 2 至 5 个导航项。普通 Tab 分别引用独立装修页；动作按钮直接打开业务地址。</p>
    </section>
    <section v-else-if="previewHasTabbar" class="ren-page-inspector__tabbar-ref">
      <div>
        <strong>底部 TabBar 由 App 壳统一管理</strong>
        <span>当前是 {{ page.title || pageCode }} 页面，切换到 App 壳后可添加、删除和排序导航。</span>
      </div>
      <RrButton type="primary" size="small" @click="emit('select-app')">管理 TabBar</RrButton>
    </section>

    <section class="ren-page-inspector__presets" aria-label="主题配色">
      <header>
        <strong>一键配色 <TemplateLockMark :locked="templateBound && !canApplyThemePreset" /></strong>
        <span>统一改变按钮、金刚位、强调文字和页面背景</span>
      </header>
      <div class="ren-page-inspector__preset-list">
        <RrButton
          v-for="preset in themePresets"
          :key="preset.code"
          size="small"
          :type="page.themePreset === preset.code ? 'primary' : 'default'"
          :disabled="readonly || !canApplyThemePreset"
          :title="canApplyThemePreset || !templateBound ? preset.name : '该字段由业务模板锁定'"
          @click="emit('apply-preset', preset.code)">
          <i class="ren-page-inspector__swatch" :style="{ background: preset.primaryColor }"></i>
          {{ preset.name }}
        </RrButton>
      </div>
    </section>

    <div class="ren-page-inspector__color-grid">
      <RrFormItem v-for="field in pageColorFields" :key="field.code">
        <template #label>
          {{ field.label }}
          <TemplateLockMark :locked="isLocked(field.code)" />
        </template>
        <RrColorPicker
          :disabled="isDisabled(field.code)"
          :title="fieldTitle(field.code)"
          :model-value="String(colorValue(field.code))"
          @update:model-value="(val) => emit('update:page', field.code, String(val))"
        />
      </RrFormItem>
    </div>
    <RrFormItem>
      <template #label>
        背景图片
        <TemplateLockMark :locked="isLocked('backgroundImage')" />
      </template>
      <RrInput
        :disabled="isDisabled('backgroundImage')"
        :title="fieldTitle('backgroundImage')"
        :value="page.backgroundImage ? String(page.backgroundImage) : ''"
        placeholder="请输入图片 URL"
        @update:value="(val) => emit('update:page', 'backgroundImage', String(val))"
      />
    </RrFormItem>
    <div class="ren-page-inspector__metrics">
      <RrFormItem>
        <template #label>
          全局圆角
          <TemplateLockMark :locked="isLocked('radius')" />
        </template>
        <RrInputNumber
          :disabled="isDisabled('radius')"
          :title="fieldTitle('radius')"
          :value="themeTokens.radius"
          :min="0"
          :max="24"
          @update:value="(val) => emit('update:page', 'radius', Number(val || 0))"
        />
      </RrFormItem>
      <RrFormItem>
        <template #label>
          组件间距
          <TemplateLockMark :locked="isLocked('spacing')" />
        </template>
        <RrInputNumber
          :disabled="isDisabled('spacing')"
          :title="fieldTitle('spacing')"
          :value="themeTokens.spacing"
          :min="8"
          :max="32"
          @update:value="(val) => emit('update:page', 'spacing', Number(val || 8))"
        />
      </RrFormItem>
    </div>
    <p v-if="layoutMode !== 'FREE'" class="ren-page-inspector__hint">
      固化页面会保护必需区块的结构和顺序；区块内容、样式、数据源和全局配色仍可调整。
    </p>
    <details class="ren-decoration-json">
      <summary>页面 JSON</summary>
      <pre>{{ schemaJson }}</pre>
    </details>
  </RrForm>
</template>

<script setup lang="ts">
import { ArrowDown, ArrowUp, Trash2 } from '@lucide/vue'
import {
  RrButton,
  RrColorPicker,
  RrForm,
  RrFormItem,
  RrInput,
  RrInputNumber,
  RrSelect,
  RrSwitch,
} from '@xjlv2/ui'
import type { RenDecorationSchema, RenDecorationTabBar, RenDecorationTabBarItem, RenDecorationThemeTokens } from '../../types'
import TemplateLockMark from '../utils/TemplateLockMark'
import { headerModeOptions, layoutModeOptions, themePresets } from './page-theme'

const tabbarColorFields = [
  { code: 'color', label: '默认文字' },
  { code: 'selectedColor', label: '选中颜色' },
  { code: 'backgroundColor', label: '导航背景' },
  { code: 'borderColor', label: '分割线' },
] as const

const pageColorFields = [
  { code: 'themeColor', label: '品牌主色' },
  { code: 'accentColor', label: '辅助强调色' },
  { code: 'backgroundColor', label: '背景色' },
  { code: 'cardColor', label: '卡片色' },
  { code: 'textColor', label: '正文色' },
  { code: 'mutedTextColor', label: '弱文字色' },
  { code: 'buttonTextColor', label: '按钮文字' },
] as const

const props = withDefaults(
  defineProps<{
    page: RenDecorationSchema['page']
    tabbar: RenDecorationTabBar
    themeTokens: RenDecorationThemeTokens
    layoutMode: string
    headerMode: string
    tabbarShellPage?: boolean
    previewHasTabbar?: boolean
    pageCode?: string
    schemaJson?: string
    readonly?: boolean
    templateBound?: boolean
    canApplyThemePreset?: boolean
    linkTargetCount?: number
    canEditPage?: (key: string) => boolean
  }>(),
  {
    tabbarShellPage: false,
    previewHasTabbar: false,
    pageCode: '',
    schemaJson: '{}',
    readonly: false,
    templateBound: false,
    canApplyThemePreset: true,
    linkTargetCount: 0,
    canEditPage: () => true,
  },
)

const emit = defineEmits<{
  'update:page': [key: string, value: unknown]
  'apply-preset': [code: string]
  'tabbar-change': [key: string, value: unknown]
  'tabbar-item-change': [index: number, key: string, value: unknown]
  'tabbar-item-code': [index: number, code: string]
  'tabbar-add': []
  'tabbar-move': [index: number, offset: -1 | 1]
  'tabbar-remove': [index: number]
  'tabbar-action': [index: number, action: boolean]
  'tabbar-prominent': [index: number, prominent: boolean]
  'tabbar-open-nav': [index: number]
  'tabbar-open-page': [item: RenDecorationTabBarItem]
  'select-app': []
}>()

function isDisabled(key: string): boolean {
  return props.readonly || !props.canEditPage(key)
}

function isLocked(key: string): boolean {
  return props.templateBound && !props.canEditPage(key)
}

function fieldTitle(key: string): string {
  return isLocked(key) ? '该字段由业务模板锁定' : ''
}

function colorValue(code: string): string {
  if (code === 'themeColor') return String(props.page.themeColor || props.themeTokens.primaryColor)
  if (code === 'backgroundColor') return String(props.page.backgroundColor || props.themeTokens.backgroundColor)
  return String((props.themeTokens as unknown as Record<string, unknown>)[code] ?? '')
}

function tabbarColor(code: (typeof tabbarColorFields)[number]['code']): string {
  return String(props.tabbar[code] || '')
}
</script>

<style scoped>
.ren-page-inspector {
  display: grid;
  gap: var(--rr-space-3);
}

.ren-page-inspector__tabbar,
.ren-page-inspector__tabbar-ref,
.ren-page-inspector__presets,
.ren-page-inspector__tab {
  display: grid;
  gap: var(--rr-space-3);
  padding: var(--rr-space-3);
  border: 1px solid var(--rr-color-border);
  border-radius: var(--rr-radius-control, 6px);
  background: var(--rr-color-surface);
}

.ren-page-inspector__tabbar header,
.ren-page-inspector__tab header,
.ren-page-inspector__tabbar-ref,
.ren-page-inspector__presets header,
.ren-page-inspector__tab-target {
  display: flex;
  justify-content: space-between;
  gap: var(--rr-space-3);
  align-items: flex-start;
}

.ren-page-inspector__tabbar header span,
.ren-page-inspector__hint,
.ren-page-inspector__tab span,
.ren-page-inspector__presets header span {
  display: block;
  color: var(--rr-color-text-muted);
  font-size: var(--rr-font-size-xs, 12px);
}

.ren-page-inspector__color-grid,
.ren-page-inspector__tab-fields,
.ren-page-inspector__metrics {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--rr-space-3);
}

.ren-page-inspector__tab-actions,
.ren-page-inspector__preset-list,
.ren-page-inspector__switches {
  display: flex;
  flex-wrap: wrap;
  gap: var(--rr-space-2);
}

.ren-page-inspector__switch {
  display: flex;
  align-items: center;
  gap: var(--rr-space-2);
  font-size: var(--rr-font-size-sm, 13px);
}

.ren-page-inspector__swatch {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 99px;
}

.ren-page-inspector :deep(.rr-form-item) {
  margin-bottom: 0;
}

.ren-page-inspector :deep(.rr-form-item__label-text) {
  display: inline-flex;
  align-items: center;
  gap: var(--rr-space-1);
}
</style>
